/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Execution_Type_TimeInputs */

const fr_execution_type_time = /** @type {(inputs: Execution_Type_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps`)
};

/**

* @param {Execution_Type_TimeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const execution_type_time = /** @type {((inputs?: Execution_Type_TimeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Execution_Type_TimeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_execution_type_time(inputs)
});